/**
 * Terms and Privacy live on the public site (lukaaji.com/{lang}/terms.html, privacy.html).
 */
import type { Language } from '@/types';

export const SITE_URL = 'https://lukaaji.com';

export type LegalDocument = 'terms' | 'privacy';

/** Site pages the app links or redirects to. */
export type SitePage = LegalDocument | 'faq' | 'method' | 'contact';

/** App language → public-site language directory (the site serves all 12 under the same codes). */
const SITE_LANGUAGE: Record<Language, string> = {
  me: 'me',
  en: 'en',
  sr: 'sr',
  hr: 'hr',
  bs: 'bs',
  sl: 'sl',
  mk: 'mk',
  sq: 'sq',
  bg: 'bg',
  ro: 'ro',
  el: 'el',
  tr: 'tr',
};

export function sitePageUrl(page: SitePage, language: Language): string {
  return `${SITE_URL}/${SITE_LANGUAGE[language]}/${page}.html`;
}

export function legalUrl(document: LegalDocument, language: Language): string {
  return sitePageUrl(document, language);
}

/** Leave the app for `url` without a history entry (routes whose page lives on the site hand over to it). */
export function replaceLocation(url: string): void {
  window.location.replace(url);
}
